import React, { useState, useEffect } from 'react';
import { trackEvent } from "../../utils/Analytics";
import FounderImage from "../../images/founder.png";
import DeckImage from "../../images/deck-mockup.png";
import LettuceLogo from "../../images/logo.png";
import { ActionButton } from "../../components/Buttons";
import DigitalWallBackground from "../../components/DigitalWallBackground";
import { MCAAD_WALL_REFINE_PATH } from "../../utils/empathyAI/refineContexts";
import { DEFAULT_WALL_PATH } from "../../utils/cards/cardConstants";

const BRAND_COLORS = {
  lettuceGreen: '#307609',
  bgCream: '#fffdf1'
};

const HERO_CONTENT = {
  collaborationLabel: "A Collaboration",
  collaborationTitle: "LettuceTalk & MCAAD",
  headline: "A Living Wall of Care",
  // headlineAccent: "one question.",
  // body: "Add your card to our growing wall of care.",
  primaryCta: "Create Card",
  secondaryCta: "View the Wall",
  // institution: "Milken Center for Advancing the American Dream"
};

const HeroCTAContent = ({ colors }) => (
  <div className="absolute left-1/2 top-[46%] z-40 w-[min(90vw,560px)] -translate-x-1/2 -translate-y-1/2 text-center">
    <div className="relative mx-auto rounded-[2rem] border border-[#f4d94e]/58 bg-[radial-gradient(circle_at_50%_0%,rgba(255,255,255,0.96)_0%,rgba(255,255,255,0.72)_28%,rgba(255,248,190,0.62)_58%,rgba(255,255,255,0.54)_100%)] px-6 pb-8 pt-14 shadow-[0_0_38px_rgba(244,217,78,0.42),0_28px_90px_rgba(78,67,24,0.2),inset_0_0_34px_rgba(255,255,255,0.72)] backdrop-blur-xl sm:rounded-[2.25rem] sm:px-10 sm:pb-10 sm:pt-16">
      <div className="pointer-events-none absolute -inset-px rounded-[2rem] bg-[linear-gradient(135deg,rgba(255,255,255,0.72),transparent_38%,rgba(244,217,78,0.26)_72%,rgba(255,255,255,0.62))] opacity-80 sm:rounded-[2.25rem]" />
      <div className="pointer-events-none absolute left-1/2 top-0 h-7 w-28 -translate-x-1/2 -translate-y-[38%] rounded-full border border-[#f4d94e]/38 bg-[#fff7b8]/54 shadow-[0_0_28px_rgba(244,217,78,0.55),inset_0_0_14px_rgba(255,255,255,0.7)]" />
      <div
        className="absolute left-1/2 top-0 z-10 flex h-24 w-24 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-white/80 bg-[radial-gradient(circle_at_34%_24%,rgba(255,255,255,0.98)_0%,rgba(255,255,255,0.78)_34%,rgba(255,253,241,0.42)_66%,rgba(255,244,140,0.2)_100%)] shadow-[0_0_54px_rgba(255,255,255,0.95),0_0_42px_rgba(244,217,78,0.55),0_18px_42px_rgba(78,67,24,0.18),inset_0_0_18px_rgba(255,255,255,0.92)] backdrop-blur-md sm:h-28 sm:w-28"
        style={{ colorScheme: "light" }}
      >
        <div className="pointer-events-none absolute inset-2 rounded-full" />
        <div className="pointer-events-none absolute left-5 top-4 h-8 w-8 rounded-full bg-white/74 blur-[2px] sm:left-6 sm:top-5 sm:h-9 sm:w-9" />
        <img
          src={LettuceLogo}
          alt="LettuceTalk"
          className="relative h-[72px] w-[72px] object-contain drop-shadow-[0_8px_14px_rgba(48,118,9,0.2)] sm:h-[86px] sm:w-[86px] p-1"
        />
      </div>
      <div className="relative z-[1] space-y-3">
        <div className="flex items-center justify-center gap-3">
          <div className="h-[1px] w-8 bg-gray-300" />
          <span className="font-sans text-[10px] font-bold uppercase tracking-[0.28em] text-gray-500 sm:text-[11px]">
            {HERO_CONTENT.collaborationLabel}
          </span>
          <div className="h-[1px] w-8 bg-gray-300" />
        </div>

        <p className="font-sans text-[12px] font-black uppercase tracking-[0.22em] text-gray-700 sm:text-[22px]">
          {HERO_CONTENT.collaborationTitle}
        </p>
      </div>

      <h1
        id="public-wall-title"
        className="relative z-[1] mx-auto mt-5 max-w-[460px] font-serif text-3xl font-medium leading-[0.92] tracking-[-0.035em] text-gray-950 sm:text-5xl"
      >
        {HERO_CONTENT.headline}
        {HERO_CONTENT.headlineAccent && (
          <span
            className="block italic"
            style={{ color: colors.lettuceGreen }}
          >
            {HERO_CONTENT.headlineAccent}
          </span>
        )}
      </h1>

      {HERO_CONTENT.body && (
        <p className="relative z-[1] mx-auto mt-4 max-w-[310px] font-sans text-[14px] leading-relaxed text-gray-700 sm:text-base">
          {HERO_CONTENT.body}
        </p>
      )}

      <div className="relative z-[1] mx-auto mt-6 flex max-w-xs flex-col items-center gap-3">
        <ActionButton
          href={MCAAD_WALL_REFINE_PATH}
          onClick={() => trackEvent("CTA", "Add My Card Hero", "MCAAD")}
          fullWidth
          icon="plus"
          size="lg"
        >
          {HERO_CONTENT.primaryCta}
        </ActionButton>

        <ActionButton
          href={DEFAULT_WALL_PATH}
          onClick={() => trackEvent("CTA", "Explore Wall Hero", "MCAAD")}
          fullWidth
          icon="users"
          variant="secondaryWarm"
        >
          {HERO_CONTENT.secondaryCta}
        </ActionButton>
      </div>

      {HERO_CONTENT.institution && (
        <p className="relative z-[1] mx-auto mt-6 max-w-xs font-sans text-[10px] leading-relaxed tracking-[0.12em] text-gray-400 uppercase">
          {HERO_CONTENT.institution}
        </p>
      )}
    </div>
  </div>
);

const ScrollMoreIcon = () => (
  <a
    className="mcaad-scroll-more absolute bottom-6 left-1/2 z-40 flex -translate-x-1/2 flex-col items-center gap-2 font-sans text-[10px] font-black uppercase tracking-[0.2em] text-[#2f2a16]/70 transition-colors hover:text-[#245c07]"
    aria-label="Scroll for more"
  >
    <span>Scroll</span>
    <span className="h-4 w-4 rotate-45 border-b-2 border-r-2 border-current" aria-hidden="true" />
  </a>
);

const MCAADDemoView = () => {
  const [copied, setCopied] = useState(false);

  const copyDiscount = () => {
    const code = "MCAAD20";
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
    trackEvent("Engagement", "Discount copied", code);
  };

  const colors = BRAND_COLORS;
  const nextSteps = [
    {
      title: "Enter a question you have for a loved one.",
      body: "Type the card you just wrote, or start a new one while the feeling is still close."
    },
    {
      title: "Add empathetic framings and translations with our AI tools.",
      body: "LettuceTalk's Empathy AI can help you find the words to express your intent across language, cultural, and generational barriers."
    },
    {
      title: "Send it with care",
      body: "Save your new LettuceTalkcard to your growing deck, and share it with someone you love or anonymously to our digital wall."
    }
  ];

  return (
    <div className="min-h-screen flex flex-col font-serif overflow-x-hidden" style={{ backgroundColor: colors.bgCream }}>
      <style>
        {`
          @keyframes wall-card-scroll {
            0% { transform: translate3d(-250px, 0, 0); opacity: 0; }
            8% { opacity: 1; }
            86% { opacity: 1; }
            100% { transform: translate3d(calc(100% + 250px), 0, 0); opacity: 0; }
          }

          @keyframes wall-card-sway {
            0%, 100% { transform: translate3d(0, 0, 0) rotate(var(--card-rotate)); }
            28% { transform: translate3d(0, var(--card-sway), 0) rotate(calc(var(--card-rotate) + 2deg)); }
            58% { transform: translate3d(0, calc(var(--card-sway) * -0.65), 0) rotate(calc(var(--card-rotate) - 1.4deg)); }
            82% { transform: translate3d(0, calc(var(--card-sway) * 0.35), 0) rotate(calc(var(--card-rotate) + 0.8deg)); }
          }

          @keyframes carried-card-reveal {
            0%, 8% { opacity: 0; transform: translateY(14px) scale(0.94); }
            16%, 82% { opacity: 1; transform: translateY(0) scale(1); }
            100% { opacity: 0.92; transform: translateY(6px) scale(0.98); }
          }

          @keyframes light-thread-drift {
            0%, 100% { transform: translate3d(-3%, 0, 0); opacity: 0.62; }
            50% { transform: translate3d(3%, -10px, 0); opacity: 0.92; }
          }

          @keyframes scroll-more-drift {
            0%, 100% { transform: translate3d(-50%, 0, 0); opacity: 0.58; }
            50% { transform: translate3d(-50%, 8px, 0); opacity: 1; }
          }

          @media (prefers-reduced-motion: reduce) {
            .mcaad-motion-card,
            .mcaad-scroll-more {
              animation: none !important;
            }
          }

          .mcaad-scroll-more {
            animation: scroll-more-drift 2.8s ease-in-out infinite;
          }
        `}
      </style>
      <main className="w-full overflow-x-hidden pt-0 pb-24">

        {/* 1. QR LANDING HERO */}
        <section className="relative min-h-[100svh] w-full max-w-none text-center">
          <div
            className="relative min-h-[100svh]"
            aria-labelledby="public-wall-title"
          >
            <div className="relative min-h-[100svh] overflow-hidden">
              <DigitalWallBackground />
              <HeroCTAContent colors={colors} />
              <ScrollMoreIcon />
            </div>
          </div>
        </section>

        <div className="mx-auto max-w-xl space-y-16 px-5 pt-16 sm:space-y-20 sm:px-6">
        <section id="mcaad-after-hero" className="space-y-7 text-center scroll-mt-8">
          <div className="space-y-5">
            <h2 className="text-4xl font-medium leading-[0.95] tracking-tight text-gray-900 sm:text-6xl">
              From hard question to compassionate conversation.
            </h2>
            <p className="mx-auto max-w-md font-sans text-base leading-relaxed text-gray-600">
              Use LettuceTalk's empathy AI tools to polish your question, translate it, and share your question to our digital wall or the loved one you wrote it for.
            </p>
          </div>

          <div className="space-y-3">
            <ActionButton
              href={MCAAD_WALL_REFINE_PATH}
              fullWidth
              icon="plus"
              size="lg"
            >
              Add Your Card
            </ActionButton>
            <ActionButton
              href={DEFAULT_WALL_PATH}
              fullWidth
              icon="users"
              size="lg"
              variant="secondaryWarm"
            >
              See the Public Wall
            </ActionButton>
          </div>
        </section>

        {/* 2. GUIDED DIGITAL EXPERIENCE */}
        <section className="relative overflow-hidden rounded-[2rem] border border-white/70 bg-[#fbf4d6] p-6 shadow-[0_24px_70px_rgba(78,67,24,0.12)] sm:p-8">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_8%,rgba(255,255,255,0.96)_0%,rgba(255,255,255,0.62)_18%,transparent_42%),radial-gradient(circle_at_18%_36%,rgba(255,255,255,0.34),transparent_28%),radial-gradient(circle_at_82%_58%,rgba(255,248,207,0.46),transparent_30%),radial-gradient(circle_at_45%_78%,rgba(255,255,255,0.28),transparent_34%),linear-gradient(180deg,#fff7d2_0%,#fffdf1_50%,#f1e4b8_100%)]" />
          <div className="absolute left-[12%] top-[14%] aspect-square w-32 rounded-full bg-white/36 blur-2xl" />
          <div className="absolute right-[10%] top-[38%] aspect-square w-40 rounded-full bg-[#fff8cf]/42 blur-2xl" />
          <div className="absolute left-1/2 bottom-[4%] aspect-square w-44 -translate-x-1/2 rounded-full bg-white/28 blur-3xl" />

          <svg className="pointer-events-none absolute inset-x-[-30%] top-[16%] z-0 h-[48%] w-[160%] overflow-visible opacity-70" viewBox="0 0 1400 520" preserveAspectRatio="none" fill="none" aria-hidden="true" style={{ animation: "light-thread-drift 24s ease-in-out infinite" }}>
            <path d="M-70 130 C140 18 258 196 446 104 C614 22 748 66 908 146 C1074 230 1204 128 1470 70" stroke="rgba(255,255,255,0.68)" strokeWidth="3" strokeLinecap="round" />
            <path d="M-80 234 C92 136 250 256 428 196 C630 128 768 166 930 254 C1110 350 1244 224 1480 176" stroke="rgba(255,255,255,0.44)" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M-60 324 C154 250 286 364 488 292 C690 220 808 282 1008 334 C1192 382 1284 294 1470 252" stroke="rgba(255,255,255,0.34)" strokeWidth="2" strokeLinecap="round" />
            <circle cx="260" cy="112" r="4" fill="white" />
            <circle cx="260" cy="112" r="16" fill="rgba(255,255,255,0.24)" />
            <circle cx="790" cy="178" r="4" fill="white" />
            <circle cx="790" cy="178" r="18" fill="rgba(255,255,255,0.22)" />
          </svg>

          <div className="relative z-10 space-y-5">
            <div className="space-y-3 text-center">
              <p className="font-sans text-[11px] font-black uppercase tracking-[0.24em] text-[#307609]">
                Three gentle steps
              </p>
              <h2 className="text-2xl font-bold leading-tight tracking-tight text-gray-950">
                Asking about caregiving is difficult. LettuceTalk makes it easier.
              </h2>
              <p className="mx-auto max-w-md font-sans text-[15px] leading-relaxed text-gray-600">
                LettuceTalk helps turn an honest question into a gentle invitation for a real conversation.
              </p>
            </div>

            <div className="grid gap-3">
              {nextSteps.map((step, index) => (
                <div key={step.title} className="flex gap-4 rounded-2xl border border-white/70 bg-white/72 p-5 shadow-[0_14px_36px_rgba(78,67,24,0.08)] backdrop-blur-md">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#307609]/10 font-sans text-sm font-black text-[#307609] shadow-inner">
                    {index + 1}
                  </div>
                  <div className="space-y-1 text-left">
                    <h3 className="font-sans text-base font-bold text-gray-900">{step.title}</h3>
                    <p className="font-sans text-sm leading-relaxed text-gray-600">{step.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 5. FOUNDER STATEMENT */}
        <section className="bg-[#f9f8f0] p-10 rounded-2xl border border-gray-200/50 space-y-8">
          <div className="flex items-center gap-4">
            <img src={FounderImage} alt="Michelle" className="w-16 h-16 rounded-full object-cover border-2 border-white shadow-sm" />
            <div className="text-left">
              <p className="font-sans font-bold text-gray-900 leading-none">Michelle Park</p>
              <p className="font-sans text-[10px] text-gray-500 uppercase tracking-widest pt-1">Creator of LettuceTalk & Milken Scholar</p>
            </div>
          </div>
          <blockquote className="font-serif text-xl text-gray-800 leading-relaxed italic border-l-4 border-[#307609]/20 pl-6">
            "I originally created LettuceTalk for my mom as we prepared for her care. I'm honored to bring this piece of my story to MCAAD."
          </blockquote>
          <p>Stop by MCAAD's Tapestry of Dreams to see Michelle's story.</p>
        </section>

        </div>
      </main>
    </div>
  );
};

export default MCAADDemoView;
